import dayjs from "dayjs";
import * as Yup from "yup";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import {
  ATTRIBUTE_ORDER,
  capitalizeFirstLetter,
  ROLE,
} from "../../../helpers/utils";

dayjs.extend(isSameOrAfter);

export enum OrderStepsEnum {
  CUSTOMER_DETAILS = "customer-details",
  BESPOKE_ITEMS = "bespoke-items",
  PRODUCTS = "products",
  ADDITIONAL_INFO = "additional-info",
  ACCESSORIES = "accessories",
  SERVICES = "services",
  BOM_DETAILS = "bom-details",
  LOAD_NOTICES = "load-notice",
  DESIGNS = "designs",
  INSTALLATION_CHECKLIST = "installation-checklist",
  COLLECTION_DELIVERY = "delivery-location",
  NOTES = "notes",
  PRODUCTION_PLANNING = "production-planning",
  QUALITY_CHECKLIST = "quality-checklist",
  INSTALLATION_PLANNING = "installation-planning",
  DISPATCH_PLANNING = "dispatch-planning",
  MEZZANINE_DISPATCH_PLANNING = "mezzanine-dispatch-planning",
  STICKER_JOBS = "sticker-jobs",
  JOBS = "jobs",
  Closed = "closed",
}

export enum OrderStatusEnum {
  ORDER_CREATED = "order_created",
  PRODUCTION_PLANNING = "production_planning",
  PRODUCTION_STARTED = "production_started",
  READY_FOR_DISPATCH = "ready_for_dispatch",
  DISPATCHED = "dispatched",
  DELIVERED = "delivered",
  UNDER_INSTALLATION = "under_installation",
  INSTALLED = "installed",
  CLOSED = "closed",
}

export const ORDER_NAXT_STATUS_FLOW: any = [
  {
    id: 1,
    key: "Order Created",
    status: OrderStatusEnum.ORDER_CREATED,
    title: "Production Planning Completed, Are You Sure?",
    isProduction: true,
    isInstallation: true,
    description:
      "This action will finalize the production planning and move the order to the next stage. Please make sure all details are correct before proceeding.",
  },
  {
    id: 2,
    key: "Ready for Production",
    status: OrderStatusEnum.PRODUCTION_PLANNING,
    title: "Production Planning Completed, Are You Sure?",
    isProduction: true,
    isInstallation: false,
    description:
      "This action will finalize the production planning and move the order to the next stage. Please make sure all details are correct before proceeding.",
  },
  {
    id: 3,
    key: "Production Started",
    status: OrderStatusEnum.PRODUCTION_STARTED,
    title: "Production Started, Are You Sure?",
    isProduction: true,
    isInstallation: false,
    description:
      "Starting production will update the order status and notify relevant teams. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 4,
    key: "Production Completed",
    status: OrderStatusEnum.READY_FOR_DISPATCH,
    title: "Production Completed, Are You Sure?",
    isProduction: true,
    isInstallation: false,
    description:
      "Marking production as completed will update the order status and notify relevant teams. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 5,
    key: "Dispatched",
    status: OrderStatusEnum.DISPATCHED,
    title: "Dispatch Completed, Are You Sure?",
    isProduction: true,
    isInstallation: false,
    description:
      "Marking dispatch as completed will update the order status and notify the customer or relevant teams. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 6,
    key: "Delivered",
    status: OrderStatusEnum.DELIVERED,
    title: "Delivered, Are You Sure?",
    isProduction: true,
    isInstallation: true,
    description:
      "Marking this order as delivered will update its status and notify the customer. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 7,
    key: "Installation Started",
    status: OrderStatusEnum.UNDER_INSTALLATION,
    title: "Installation Started, Are You Sure?",
    isProduction: false,
    isInstallation: true,
    description:
      "Starting installation will update the order status and notify the assigned team. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 8,
    key: "Installation Completed",
    status: OrderStatusEnum.INSTALLED,
    title: "Installation Completed, Are You Sure?",
    isProduction: false,
    isInstallation: true,
    description:
      "Marking installation as completed will update the order status and notify the relevant teams or customer. Please confirm before proceeding, as this action cannot be undone.",
  },
  {
    id: 9,
    key: "Invoiced",
    status: OrderStatusEnum.CLOSED,
    title: "Order Invoiced, Are You Sure?",
    isProduction: true,
    isInstallation: true,
    description:
      "Invoiced this order will mark it as fully completed and no further actions or updates will be allowed. Please confirm before proceeding.",
  },
];

export const OrderStatusLabels: Record<OrderStatusEnum, string> = {
  [OrderStatusEnum.ORDER_CREATED]: "Order Created",
  [OrderStatusEnum.PRODUCTION_PLANNING]: "Ready for Production",
  [OrderStatusEnum.PRODUCTION_STARTED]: "Production Started",
  [OrderStatusEnum.READY_FOR_DISPATCH]: "Ready For Dispatch",
  [OrderStatusEnum.DISPATCHED]: "Dispatched",
  [OrderStatusEnum.DELIVERED]: "Delivered",
  [OrderStatusEnum.UNDER_INSTALLATION]: "Under Installation",
  [OrderStatusEnum.INSTALLED]: "Installed",
  [OrderStatusEnum.CLOSED]: "Invoiced",
};

export const PoductStartEditArray = [
  OrderStatusEnum.ORDER_CREATED,
  OrderStatusEnum.PRODUCTION_PLANNING,
  OrderStatusEnum.PRODUCTION_STARTED,
];
export const DeliveryStatusArray = [
  OrderStatusEnum.ORDER_CREATED,
  OrderStatusEnum.PRODUCTION_PLANNING,
  OrderStatusEnum.PRODUCTION_STARTED,
  OrderStatusEnum.READY_FOR_DISPATCH,
  OrderStatusEnum.DISPATCHED,
];
export const InstallationStatusArray = [
  OrderStatusEnum.ORDER_CREATED,
  OrderStatusEnum.PRODUCTION_PLANNING,
  OrderStatusEnum.PRODUCTION_STARTED,
  OrderStatusEnum.READY_FOR_DISPATCH,
  OrderStatusEnum.DISPATCHED,
  OrderStatusEnum.DELIVERED,
  OrderStatusEnum.UNDER_INSTALLATION,
];

export const DispatchPlaningStatusArray = [
  OrderStatusEnum.ORDER_CREATED,
  OrderStatusEnum.PRODUCTION_PLANNING,
  OrderStatusEnum.PRODUCTION_STARTED,
  OrderStatusEnum.READY_FOR_DISPATCH,
];
export const OrderStatusDropDownList = [
  { value: OrderStatusEnum.ORDER_CREATED, key: "Order Created" },
  { value: OrderStatusEnum.PRODUCTION_PLANNING, key: "Ready for Production" },
  { value: OrderStatusEnum.PRODUCTION_STARTED, key: "Production Started" },
  { value: OrderStatusEnum.READY_FOR_DISPATCH, key: "Ready For Dispatch" },
  { value: OrderStatusEnum.DISPATCHED, key: "Dispatched" },
  { value: OrderStatusEnum.DELIVERED, key: "Delivered" },
  { value: OrderStatusEnum.UNDER_INSTALLATION, key: "Under Installation" },
  { value: OrderStatusEnum.INSTALLED, key: "Installed" },
  { value: OrderStatusEnum.CLOSED, key: "Invoiced" },
];

export const getOrderStatusOptions = () => {
  return Object.values(OrderStatusEnum).map((value) => ({
    label: OrderStatusLabels[value],
    value: value,
  }));
};

const transformDayjsToDate = (value: any, originalValue: any) => {
  if (!originalValue) return null;
  if (dayjs.isDayjs(originalValue)) {
    return originalValue.toDate();
  }
  if (typeof originalValue === "string") {
    const d = dayjs(originalValue);
    return d.isValid() ? d.toDate() : value;
  }
  return value;
};

export const PlaningHeaderValidationSchema = Yup.object().shape({
  production_start_date: Yup.date()
    .transform(transformDayjsToDate)
    .typeError("Invalid date")
    .nullable()
    .required("Production start date is required"),

  production_completion_date: Yup.date()
    .transform(transformDayjsToDate)
    .typeError("Invalid date")
    .nullable()
    .required("Production completion date is required")
    .test(
      "after-production-start",
      "Production completion date cannot be before production start date",
      function (value) {
        const { production_start_date } = this.parent;
        if (!value || !production_start_date) return true;
        return dayjs(value).isSameOrAfter(dayjs(production_start_date), "day");
      },
    ),

  delivery_date: Yup.date()
    .transform(transformDayjsToDate)
    .typeError("Invalid date")
    .nullable()
    .required("Delivery date is required")
    .test(
      "after-production-end",
      "Delivery date cannot be before production completion date",
      function (value) {
        const { production_completion_date } = this.parent;
        if (!value || !production_completion_date) return true;
        return dayjs(value).isSameOrAfter(
          dayjs(production_completion_date),
          "day",
        );
      },
    ),
  installation_planning: Yup.boolean(),

  installation_date: Yup.date()
    .transform(transformDayjsToDate)
    .typeError("Invalid date")
    .nullable()
    .when("installation_planning", {
      is: true,
      then: (schema) =>
        schema
          .required("Installation date is required")
          .test(
            "after-delivery-date",
            "Installation date cannot be before or same as delivery date",
            function (value) {
              const { delivery_date } = this.parent;
              if (!value || !delivery_date) return true;
              return dayjs(value).isAfter(dayjs(delivery_date), "day");
            },
          ),
      otherwise: (schema) => schema.nullable().notRequired(),
    }),
});

export const ManufacturingStatus: any = [
  { label: "Scheduled", value: "scheduled", color: "#949494" },
  { label: "Started", value: "started", color: "#FF8000" },
  { label: "Completed", value: "completed", color: "#419F20" },
  ,
];

export const formatAttributes = (attrs: any) => {
  if (!attrs) return "";
  return ATTRIBUTE_ORDER.filter((def) => attrs[def.key])
    .map((def) => {
      let val = attrs[def.key];
      if (typeof val === "string") {
        val = val.split("_").map(capitalizeFirstLetter).join(" ");
      }
      return `${def.label}: ${val}`;
    })
    .join(" | ");
};

export const transformItemsByVariant = (items: any[]) => {
  const dataSource: any[] = [];
  let key = 0;

  for (const item of items ?? []) {
    if (item.item_type !== "product") continue;

    const { product, splits = [] } = item;
    if (!product?.variants?.length || !splits.length) continue;

    // 🔥 Group splits by variant_id (O(n))
    const splitMap = new Map<string, any[]>();
    for (const split of splits) {
      if (!splitMap.has(split.variant_id)) {
        splitMap.set(split.variant_id, []);
      }
      splitMap.get(split.variant_id)!.push(split);
    }

    // 🔥 Loop variants once
    for (const variant of product.variants) {
      const matchedSplits = splitMap.get(variant.variant_id);
      if (!matchedSplits?.length) continue;

      const productRow = {
        product_id: product.product_id,
        product_name: product.name,
        description: product.description,
        variants: variant,
        spacifications: formatAttributes(variant?.attributes),
        attributes: variant.attributes,
        unit_price: variant.unit_price,
        variant_qty: variant.quantity,
        total_price: variant.total_price,
        discount_percentage: variant.discount_percentage,
        discount_amount: variant.discount_amount,
        line_total: variant.line_total,

        image: product?.pre_galvanised_image
          ? product?.pre_galvanised_image
          : product?.powder_coated_image
          ? product?.powder_coated_image
          : product.hot_dip_galvanised_image,
      };

      // 🔥 Push rows directly (no second loop)
      matchedSplits.forEach((split, index) => {
        dataSource.push({
          ...split,
          department_id: split?.department_id ? split?.department_id : null,
          machine_id: split?.machine_id ? split?.machine_id : null,
          key: key++,
          product: productRow,
          item_id: item?._id,
          rowSpan: index === 0 ? matchedSplits.length : 0,
        });
      });
    }
  }

  return dataSource;
};

const normalizeItems = (items: any) => (Array.isArray(items) ? items : [items]);

export const mergeByProductId = (oldData: any[], newData: any[]) => {
  const result: any[] = [...oldData];
  // group newData by product_id
  const newDataMap = new Map<number, any[]>();
  newData.forEach((item) => {
    const productId = item?.product?.product_id;

    if (!newDataMap.has(productId)) {
      newDataMap?.set(productId, []);
    }
    newDataMap?.get(productId)!.push({
      ...item,
      items: normalizeItems(item.items),
    });
  });

  newDataMap.forEach((newItems, productId) => {
    // find first index of product in oldData
    const firstIndex = result.findIndex(
      (item) => item.product.product_id === productId,
    );

    // remove all old entries of this product
    for (let i = result.length - 1; i >= 0; i--) {
      if (result[i]?.product?.product_id === productId) {
        result.splice(i, 1);
      }
    }

    if (firstIndex !== -1) {
      // insert new items at same place
      result.splice(firstIndex, 0, ...newItems);
    } else {
      // product not found → append
      result.push(...newItems);
    }
  });

  return result;
};

export const splitArrayArrange = (
  data: any,
  newData: any,
  oldDataIndex: any,
) => {
  const result = [
    ...data.slice(0, oldDataIndex + 1), // keep up to the old index
    ...newData.slice(1), // insert new data (skip first item which is the updated old item)
    ...data.slice(oldDataIndex + 1), // rest of old data
  ];
  return result;
};

export const getNextStatus = (orderDetails: any, status: any) => {
  const filteredFlow = ORDER_NAXT_STATUS_FLOW.filter((step: any) => {
    if (orderDetails?.planning_details && orderDetails?.installation_planning) {
      return true;
    }

    if (orderDetails?.planning_details) {
      return step.isProduction;
    }

    if (orderDetails?.installation_planning) {
      return step.isInstallation;
    }

    if (
      !orderDetails?.planning_details &&
      !orderDetails?.installation_planning
    ) {
      return true;
    }
    return false;
  });
  const currentIndex = filteredFlow.findIndex(
    (step: any) => step.status === status,
  );

  return currentIndex !== -1 && currentIndex < filteredFlow.length - 1
    ? filteredFlow[currentIndex + 1]
    : null;
};

export const filteredStatusFlow = (orderDetails: any) => {
  if (!orderDetails) return [];

  const hasProduction = !!orderDetails?.planning_details;
  const hasInstallation = !!orderDetails?.installation_planning;

  var newData: any = [];
  var isOnly_Installation = false;
  if (!hasProduction && !hasInstallation) {
    return ORDER_NAXT_STATUS_FLOW?.map((elem: any) => ({
      status: elem?.status,
      title:
        isOnly_Installation && elem?.key == "Delivered"
          ? "Ready For Installation"
          : elem?.key == "Production Completed"
          ? "Ready For Dispatch"
          : elem?.key,
    }));
  }
  // If both exist → show all
  if (hasProduction && hasInstallation) {
    newData = ORDER_NAXT_STATUS_FLOW;
  }

  // Only production
  if (hasProduction && newData?.length == 0) {
    newData = ORDER_NAXT_STATUS_FLOW.filter((step: any) => step.isProduction);
  }

  // Only installation
  if (hasInstallation && newData?.length == 0) {
    isOnly_Installation = true;
    newData = ORDER_NAXT_STATUS_FLOW.filter((step: any) => step.isInstallation);
  }
  // Neither exist
  return newData?.map((elem: any) => ({
    status: elem?.status,
    title:
      isOnly_Installation && elem?.key == "Delivered"
        ? "Ready For Installation"
        : elem?.key == "Production Completed"
        ? "Ready For Dispatch"
        : elem?.key,
  }));
};

export const manageOrderTypePermission = (role: any) => {
  switch (role) {
    case ROLE.ADMIN:
      return {
        productionPlaning: true,
        dispatchPlaning: true,
        milestone: true,
      };

    case ROLE.SUB_ADMIN:
      return {
        productionPlaning: true,
        dispatchPlaning: true,
        milestone: true,
      };

    case ROLE.PRODUCTION_MANAGER:
      return {
        productionPlaning: true,
        dispatchPlaning: false,
        milestone: false,
      };
    case ROLE.DISPATCH_MANAGER:
      return {
        productionPlaning: false,
        dispatchPlaning: true,
        milestone: false,
      };
    case ROLE.CLIENT:
      return {
        productionPlaning: false,
        dispatchPlaning: false,
        milestone: false,
      };
    case ROLE.DISTRIBUTOR:
      return {
        productionPlaning: false,
        dispatchPlaning: false,
        milestone: false,
      };
    default:
      return {
        productionPlaning: false,
        dispatchPlaning: false,
        milestone: false,
      };
  }
};

export const ORDER_SCROLL_KEY = "orders_scroll_top";
export const ORDER_FILTER_KEY = "orders_filters";
export const ORDER_REFETCH_KEY = "orders_needs_refetch";
